import React, { Component } from 'react';
import { connect } from 'react-redux';

import serverClientUtil from '../../../utils/serverClientUtil';
import { shoppingBagIcon } from './svgIcons';

const maximumNumberDisplay = 9;

@connect((store) => ({
  cartCountData: store.cartCountData.data,
}))
class ShoppingBag extends Component {
  render() {
    const { cartCountData } = this.props;
    const cartCount = cartCountData?.cartHeaderDetails?.cartCount ?? 0;

    const numberProduct =
      cartCount === 0
        ? ''
        : cartCount > maximumNumberDisplay
          ? `${maximumNumberDisplay}+`
          : cartCount;

    return (
      <div className='header-shopping-bag'>
        <a
          className='cart hoverStyleCart'
          style={{ position: 'relative', marginRight: '14px' }}
          href={`${serverClientUtil.getLPURL()}/tienda/cart`}
        >
          {shoppingBagIcon('var(--white)')}
          {numberProduct && (
            <span
              className={`cartCount ${numberProduct.length > 1 ? 'cartCount__maxNum' : 'cartCount__minNum'}`}
            >
              {numberProduct}
            </span>
          )}
        </a>
      </div>
    );
  }
}

export default ShoppingBag;
